import React, { useState } from "react";
import styled from "styled-components";
// Assets
import ContactImg1 from "../../assets/img/contact-1.png";
import ContactImg2 from "../../assets/img/contact-2.png";
import ContactImg3 from "../../assets/img/contact-3.png";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const handleSend = () => {
    const to = "info@nfinitysolution.com";
    const s = encodeURIComponent(subject || "Message from website");
    const b = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\n${message}`);
    window.location.href = `mailto:${to}?subject=${s}&body=${b}`;
  };
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Let's Get in Touch</h1>
            <p className="font14">
              We'd love to hear from you. Send us a message and we'll get back to you as soon as possible.
            </p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form>
                <InputGroup>
                  <label>Name</label>
                  <input type="text" placeholder="Your Name" value={name} onChange={(e) => setName(e.target.value)} />
                </InputGroup>
                <InputGroup>
                  <label>Email</label>
                  <input type="email" placeholder="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </InputGroup>
                <InputGroup>
                  <label>Subject</label>
                  <input type="text" placeholder="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
                </InputGroup>
                <InputGroup>
                  <label>Message</label>
                  <textarea placeholder="Write your message here..." value={message} onChange={(e) => setMessage(e.target.value)} />
                </InputGroup>
                <ButtonWrapper>
                  <ButtonInput type="button" value="Send Message" onClick={handleSend} />
                </ButtonWrapper>
              </Form>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <ImageWrapper>
                <ContactImgBox>
                  <img src={ContactImg1} alt="office" />
                </ContactImgBox>
              </ImageWrapper>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  background-color: #f9f9f9;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 40px 0;
  text-align: center;
  h1 {
    color: #090f52;
  }
  p {
    color: #555;
    max-width: 500px;
    margin: 10px auto 0 auto;
  }
`;

const Form = styled.form`
  padding: 30px 20px;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1);
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  label {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 5px;
    color: #333;
  }
  input,
  textarea {
    padding: 12px 15px;
    border: 1px solid #ccc;
    border-radius: 10px;
    font-size: 16px;
    transition: all 0.3s ease;
    &:focus {
      border-color: #580cd2;
      box-shadow: 0 0 10px rgba(88, 12, 210, 0.2);
      outline: none;
    }
  }
  textarea {
    min-height: 120px;
    resize: none;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const ButtonInput = styled.input`
  border: none;
  background-color: #580cd2;
  color: #fff;
  padding: 15px 30px;
  font-size: 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background-color: #4309a0;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: stretch;
`;

const ContactImgBox = styled.div`
  width: 100%;
  height: 89%;
  margin: 0;
  img {
    width: 100%;
    height: 91%;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    &:hover {
      transform: scale(1.02);
    }
  }
`;
